export default {"src":"/_next/static/media/faqQuestion.8d93976a.svg","height":64,"width":64};